import {
  FeeScheduleMappingHandler,
  IBaseMigrationFeeSchedule,
} from '../../../mappings/fee-schedules';
import {
  D4WFeeSchedule,
  FeeScheduleSourceEntity,
  ID4WFeeSchedule,
} from '../../source/entities/fee-schedule';

export class D4WFeeScheduleMappingHandler extends FeeScheduleMappingHandler<
  D4WFeeSchedule,
  FeeScheduleSourceEntity
> {
  override sourceEntity = new FeeScheduleSourceEntity();
  translateFn = (record: ID4WFeeSchedule): IBaseMigrationFeeSchedule => ({
    ...record,
    name: record.description,
  });
}
